// import * as React from 'react';
// import PropTypes from 'prop-types';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
// import Typography from '@mui/material/Typography';
// import Box from '@mui/material/Box';
// import { Image } from '@mui/icons-material';

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//     return (
//         <div
//             role="tabpanel"
//             hidden={value !== index}
//             id={`vertical-tabpanel-${index}`}
//             aria-labelledby={`vertical-tab-${index}`}
//             {...other}
//         >
//         {value === index && (
//             <Box sx={{ p: 3 }}>
//                 <Typography>{children}</Typography>
//             </Box>
//         )}
//         </div>
//     );
// }

// TabPanel.propTypes = {
//     children: PropTypes.node,
//     index: PropTypes.number.isRequired,
//     value: PropTypes.number.isRequired,
// };

// function a11yProps(index) {
//     return {
//         id: `vertical-tab-${index}`,
//         'aria-controls': `vertical-tabpanel-${index}`,
//     };
// }

// export default function VerticalTabs({ itemList, selectedItem, type, onSelect }) {
//     const [value, setValue] = React.useState(0);

//     const handleChange = (event, newValue) => {
//         setValue(newValue);
//         if (typeof onSelect === 'function' && itemList[newValue]) onSelect(itemList[newValue], newValue);
//     };

//     React.useEffect(() => {
//         if (!selectedItem) return;
//         const idx = itemList.findIndex((it) => it?.image === selectedItem?.image);
//         if (idx >= 0) setValue(idx);
//     }, [selectedItem, itemList]);

//     return (
//         <>
//             <Box
//                 sx={{
//                     flexGrow: 1,
//                     bgcolor: 'background.paper',
//                     // display: 'flex',
//                     height: { md: 450, lg: 550 },
//                     display: { xs: 'none', sm: 'none', md: 'flex' } }}
//             >
//                 <Tabs
//                     orientation="vertical"
//                     variant="scrollable"
//                     className='thumbnail-container'
//                     value={value}
//                     onChange={handleChange}
//                     aria-label="Vertical tabs example"
//                     sx={{ borderRight: 1, borderColor: 'divider' }}
//                 >
//                     {itemList.map((item, i) =>
//                         <Tab
//                             {...a11yProps(i)}
//                             className="thumbnail"
//                             icon={<img src={item.image||item?.image_url} key={i} />}
//                         />
//                     )}
//                 </Tabs>
//                 <div className='image-container'>
//                     {itemList.map((item, i) =>
//                         <TabPanel value={value} index={i}>
//                             {type === 'image' && <img src={item.image||item?.image_url} key={i} />}
//                         </TabPanel>
//                     )}
//                 </div>
//             </Box>
//             <Box sx={{ display: { sm: 'block', md: 'none' } }}>
//                 <div className='block-image-container'>
//                     {itemList.map((item, i) =>
//                         <TabPanel value={value} index={i}>
//                             {type === 'image' && <img src={item.image||item?.image_url} key={i} />}
//                         </TabPanel>
//                     )}
//                 </div>
//                 <Tabs
//                     orientation="horizontal"
//                     variant="scrollable"
//                     className='block-thumbnail-container'
//                     value={value}
//                     onChange={handleChange}
//                     aria-label="Vertical tabs example"
//                     sx={{ borderRight: 1, borderColor: 'divider' }}
//                 >
//                     {itemList.map((item, i) =>
//                         <Tab
//                             {...a11yProps(i)}
//                             className="thumbnail"
//                             icon={<img src={item.image||item?.image_url} key={i} />}
//                         >
//                             {console.log("item",item.image)}
//                         </Tab>
//                     )}
//                 </Tabs>
//             </Box>
//         </>
//     );
// }
import React, { useState, useEffect } from "react";
import { Box, IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SaleTag from "components/SaleTag";

export default function ProductGallery({ itemList = [], discount }) {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleNext = () => {
    setActiveIndex((prev) => (prev === itemList.length - 1 ? 0 : prev + 1));
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? itemList.length - 1 : prev - 1));
  };

  if (!itemList.length) return null;

  const showArrows = itemList.length > 1;
  return (
    <Box
      sx={{
        width: "100%",

        borderRadius: "12px", // 🔥 rounded background
        mt: { xs: 2, md: 6 },
        mb: { xs: 2, md: 4 },
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          aspectRatio: "1 / 1", // ✅ Fixed square container
          borderRadius: "12px",
          overflow: "hidden",
          // backgroundColor: "red", // neutral bg (red remove karo)
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "12px",
        }}
      >
        <img
          src={itemList[activeIndex]?.image || itemList[activeIndex]?.image_url}
          alt="product"
          style={{
            width: "100%",
            height: "100%",
            maxWidth: "100%", // ✅ Prevent overflow
            maxHeight: "100%", // ✅ Prevent overflow
            objectFit: "contain", // ✅ Full image visible
          }}
        />

        <SaleTag discount={discount} bottom={16} left={16} />
      </Box>

      {/* Thumbnails */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          mt: 2,
        }}
      >
        {itemList.map((item, index) => {
          const isActive = activeIndex === index;
          return (
            <Box
              key={index}
              onClick={() => setActiveIndex(index)}
              sx={{
                width: 60,
                height: 60,
                cursor: "pointer",
                overflow: "hidden",
                borderBottom: isActive
                  ? "3px solid #000"
                  : "3px solid transparent",
                transition: "all 0.2s ease",
              }}
            >
              <img
                src={item.image || item.image_url}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  aspectRatio: "1 / 1",
                  objectFit: "contain",
                }}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
